import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export default class LogoCarousel {
	init(block) {
		const carousel = new Splide( block.querySelector('.splide'), {
			autoScroll: {
				speed: 1,
			},
			type: 'loop',
			easing: 'linear',
			gap: 150,
			pauseOnHover: false,
			autoWidth: true,
			autoStart: true,
			rewind: false,
			pagination: false,
			arrows: false,
			interval: 0,
			padding: 0,
			breakpoints: {
				1023: {
				    gap: 80
				}
			}
		} ).mount( { AutoScroll } );
    }
}